// extracted by mini-css-extract-plugin
export default {"red_text":"CaseContainer_red_text__IA96F","text_description":"CaseContainer_text_description__ZGLKw"};